import React from 'react';
import { Fragment, useState, useEffect } from 'react';
import { Row, Alert } from 'react-bootstrap';
import FormBusca from './form_busca';
import Requisicao from './requisicao';
import OuvidoriaService from '../../../services/ouvidoria';


const ListarOuvidoria = () => {

    const [requisicoes, setRequisicoes] = useState([]);
    const [vazio, setVazio] = useState(true);

    async function fetchRequisicoes() {
        const response = await OuvidoriaService.listarSigilo();
        if (response.data.length >= 1) {
            setRequisicoes(response.data)
            setVazio(false)
        } else {
            setRequisicoes([])
            setVazio(true)
        }
    }

    useEffect(() => {
        fetchRequisicoes();
    }, []);

   return (
        <Fragment>
            <Fragment>
                <FormBusca
                    setRequisicoes={setRequisicoes}
                    setVazio={setVazio}
                    fetchRequisicoes={fetchRequisicoes}
                    requisicoes={requisicoes}
                />
            </Fragment>

            {vazio ? <Fragment>
                <Alert variant='danger'>Sua busca ainda não gerou nenhum resultado :(</Alert>
            </Fragment> :
                <Fragment>
                    <Row xs={1}>
                        {requisicoes.map((requisicao, index) =>
                            <Requisicao
                                requisicao={requisicao}
                                key={index}
                            />
                        )}
                    </Row>
                </Fragment>}
        </Fragment>

    )
}

export default ListarOuvidoria;